import {
  initAnalytics,
  trackPageView,
} from './src/lib/analytics';

import './src/scss/main.scss';

export const onClientEntry = (): void => {
  initAnalytics();
};

export const onRouteUpdate = ({ location }: { location: Location }): void => {
  trackPageView(location);
};

export const onInitialClientRender = (): void => {
  if (
    typeof performance === 'undefined' ||
    !performance.mark ||
    !performance.measure
  ) {
    return;
  }

  performance.mark('site:initial-client-render');

  const markFirstIdle = (): void => {
    performance.mark('site:first-idle');
    performance.measure(
      'site:initial-render-to-first-idle',
      'site:initial-client-render',
      'site:first-idle',
    );
  };

  if (window.requestIdleCallback) {
    window.requestIdleCallback(markFirstIdle);
    return;
  }

  window.setTimeout(markFirstIdle, 0);
};
